import { Pill, PillColor, PillSize } from '@oy/uidesktop';
import { useNotificationAnnouncementData } from 'src/hooks';
import styles from './LatestInfoCountPill.module.css';

export const LatestInfoCountPill = () => {
  const { notificationUnread, bankMaintenanceUnread, whatsNewUnread } =
    useNotificationAnnouncementData();
  const totalUnread = notificationUnread + whatsNewUnread + bankMaintenanceUnread;

  return (
    <>
      {totalUnread > 0 && (
        <div className={styles.navDropdownPill}>
          <Pill color={PillColor.Red} size={PillSize.Small}>
            {totalUnread >= 100 ? '99+' : totalUnread}
          </Pill>
        </div>
      )}
    </>
  );
};
